import { Helmet } from "react-helmet-async";

const SITE_NAME = "YAFORMIS";
const SITE_URL = "https://www.gme-assistance.fr";

export default function SEO({ title, description, image, path = "/", type = "website", schema }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Formations professionnelles en intelligence artificielle`;
  const desc = description || "Organisme de formation IA. Initiation, outils IA, IA générative, agents IA. Éligible CPF / OPCO. Formateurs experts, pédagogie active.";
  const url = `${SITE_URL}${path}`;
  const img = image || `${SITE_URL}/logo-yaformis.png`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
